import React, { Component, useEffect, useState } from "react";
import ComponentChangeLanguageMobile from "./ComponentChangeLanguageMobile";
import ComponentChangeLanguageWeb from "./ComponentChangeLanguageWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentChangeLanguage = () => {
  const gaEventTracker = useAnalyticsEventTracker("ChangeLanguage");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Change Language",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentChangeLanguageWeb></ComponentChangeLanguageWeb>
      </BrowserView>
      <MobileView>
        <ComponentChangeLanguageMobile></ComponentChangeLanguageMobile>
      </MobileView>
    </>
  );
};

export default ComponentChangeLanguage;
